const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            addShippingListener();
        }
    }
});

document.addEventListener('DOMContentLoaded', initCart, false);

function initCart() {
    addShippingListener();
    addShippingOptionsListener();

    const $preselectedShippingOption = document.querySelector('.shipping-option input[type="radio"]:checked');
    if ($preselectedShippingOption) {
        addServiceTagsToShipping($preselectedShippingOption);
        $preselectedShippingOption
            ?.closest('.shipping-option')
            ?.querySelector('[aria-expanded][aria-controls]')
            ?.dispatchEvent(new CustomEvent('dhc.aria-open'));
    }
}

function addShippingOptionsListener() {
    const cartModalWindow = document.getElementById("cart-modal-window");
    if (cartModalWindow) {
        observer.observe(
            cartModalWindow,
            { childList: true, subtree: true }
        );
    }
}

function addShippingListener() {
    const shippingCountry = document.querySelector('#cart_shipping_country');
    if (shippingCountry) {
        shippingCountry.addEventListener('change', onChangeShippingCountry);
        onChangeShippingCountry({ target: shippingCountry });
        observer.disconnect();
    }

    // Any time a shipping option is opened, close all other shipping options
    const shippingForm = document.querySelector('form.edit_cart');
    if (shippingForm) {
        shippingForm.addEventListener('dhc.aria-opened', function(e) {
            shippingForm.querySelectorAll('[aria-expanded][aria-controls]').forEach((control, index) => {
                if (control !== e.target) {
                    control.dispatchEvent(new CustomEvent('dhc.aria-close'))
                }
            });
        });
        shippingForm.addEventListener('click', onClickShippingOption);
        shippingForm.addEventListener('change', onChangeShippingOption);
    }
}

function onChangeShippingCountry(e) {
    document.dispatchEvent(new CustomEvent('dhc.newAriaExpansion'));

    const shippingSectionCA = document.getElementById('CA-shipping-options');
    const shippingSectionUS = document.getElementById('US-shipping-options');

    if (e.target.value === 'CA') {
        shippingSectionCA.style.display = "block";
        shippingSectionCA.querySelectorAll('[aria-expanded][aria-controls]')[0]?.dispatchEvent(new CustomEvent('dhc.aria-open'));
        shippingSectionUS.style.display = "none";
    } else if (e.target.value === 'US') {
        shippingSectionCA.style.display = "none";
        shippingSectionUS.style.display = "block";
        shippingSectionUS.querySelectorAll('[aria-expanded][aria-controls]')[0]?.dispatchEvent(new CustomEvent('dhc.aria-open'));
    }
}

function onClickShippingOption(event) {
    if (event.target && event.target.matches("input[type='radio']")) {
        document.querySelector('.shipping-name').innerHTML = event.target.dataset.name;
        document.querySelector('.total-shipping-price').innerHTML = '$' + Number(event.target.dataset.price).toFixed(2);
        const $currentPrice = document.querySelector('.total-current-price');
        const newTotal = Number(event.target.dataset.price) + Number($currentPrice.dataset.subtotal);
        $currentPrice.innerHTML = `$${newTotal.toFixed(2)} ${$currentPrice.getAttribute('data-currency-code')}`.trim();

        addServiceTagsToShipping(event.target);
    }
}

function addServiceTagsToShipping($selectedShippingOption) {
    const $shippingRow = document.querySelector('.shipping-name').parentElement;
    const $shippingTags = $shippingRow.querySelectorAll('.service-tag');
    if ($shippingTags.length > 0) {
        $shippingTags.forEach(tag => tag.remove());
    }

    const serviceTags = JSON.parse($selectedShippingOption.dataset.serviceTags || '[]');
    if (serviceTags && Array.isArray(serviceTags)) {
        serviceTags.forEach(tag => {
            const newTag = document.createElement('div');
            newTag.classList.add('service-tag');
            newTag.innerHTML = tag;
            $shippingRow.appendChild(newTag);
        });

        const serviceTagField = document.querySelector('input[name="cart[shipping_service_tags]"]');
        if (serviceTagField) {
            serviceTagField.value = serviceTags.length > 0 ? $selectedShippingOption.dataset.serviceTags : '';
        } else {
            console.warn('Missing input[name="cart[shipping_service_tags]"]');
        }
    }
}

function onChangeShippingOption(event) {
    if (event.target && event.target.matches("input[type='radio']")) {
        event.target
            ?.closest('.shipping-option')
            ?.querySelector('[aria-expanded][aria-controls]')
            ?.dispatchEvent(new CustomEvent('dhc.aria-open'))
    }
}
